/**
 *   Created by ATopcu in 2019
 */

import { createSelector } from "reselect";
import { memoize, uniqueByKey } from "@ls/js-utils";
import SelectionState from "state/selections/SelectionState";
import SummaryType from "state/selections/Constants/SummaryType";
import scope from "./scope";

export const selectData = (summaryType) => (state) =>
  state[scope]["data"][summaryType];
export const selectFetchingData = (summaryType) => (state) =>
  state[scope]["fetchingData"][summaryType];
export const selectAltDateData = (summaryType) => (state) =>
  state[scope]["altDateData"][summaryType];
export const selectFetchingAltDateData = (summaryType) => (state) =>
  state[scope]["fetchingAltDateData"][summaryType];
export const selectFetchingFactribTypes = (state) =>
  state[scope].fetchingFactribTypes;
export const selectFactribTypes = (state) => state[scope].factribTypes;
export const selectFetchingFactribPeriods = (state) =>
  state[scope].fetchingFactribPeriods;
export const selectFactribPeriods = (state) => state[scope].factribPeriods;

export const selectDefinitions = memoize((selectionState) => {
  if (selectionState === SelectionState.UNCOMMITTED) {
    return (state) => state[scope]["definitions"][selectionState];
  }

  return createSelector(
    (state) => state[scope]["definitions"][selectionState],
    (definitions) => {
      const completeDefinitions = definitions.filter(
        ({ complete }) => complete
      );
      return completeDefinitions.filter(
        uniqueByKey(completeDefinitions, "key")
      );
    }
  );
});

export const selectRowsMap = createSelector(
  selectData(SummaryType.ABSOLUTE),
  selectData(SummaryType.RELATIVE),
  selectAltDateData(SummaryType.ABSOLUTE),
  selectAltDateData(SummaryType.RELATIVE),
  (absoluteData, relativeData, absAltDateData, relAltDateData) => {
    const rowsMap = {};
    const processData = (data, summary, altAsOfDate) => {
      const { slaSummaries = [] } = data || {};
      slaSummaries.forEach((slaSummary) => {
        const { primaryKey, valuesContrib } = slaSummary;
        const { period } = primaryKey;
        Object.keys(valuesContrib).forEach((factribFactor) => {
          let colId = `factor attrib - ${factribFactor.toUpperCase()}, ${period}, ${summary}`;
          if (altAsOfDate) {
            colId += `, ${altAsOfDate}`;
          }
          if (!rowsMap[slaSummary.primaryKey.entityId]) {
            rowsMap[slaSummary.primaryKey.entityId] = {};
          }
          rowsMap[slaSummary.primaryKey.entityId][colId] =
            valuesContrib[factribFactor];
        });
      });
    };
    processData(absoluteData, SummaryType.ABSOLUTE);
    processData(relativeData, SummaryType.RELATIVE);
    Object.keys(absAltDateData).forEach((asOfDate) =>
      processData(absAltDateData[asOfDate], SummaryType.ABSOLUTE, asOfDate)
    );
    Object.keys(relAltDateData).forEach((asOfDate) =>
      processData(relAltDateData[asOfDate], SummaryType.RELATIVE, asOfDate)
    );
    return rowsMap;
  }
);
